import React from 'react'

export function FilterIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#43D0A3"
        fillRule="evenodd"
        d="M2.319 4.186A.75.75 0 013 3.75h18a.75.75 0 01.57 1.238l-7.02 8.198V21a.75.75 0 01-1.082.672l-3.6-1.777a.75.75 0 01-.418-.673v-6.036L2.43 4.988a.75.75 0 01-.111-.802zm2.31 1.064l6.14 7.171a.75.75 0 01.181.488v5.847l2.1 1.037V12.91a.75.75 0 01.18-.488l6.14-7.171H4.63z"
        clipRule="evenodd"
      />
    </svg>
  )
}
